// extracted by mini-css-extract-plugin
export default {"verticalCenter":"_93svi16ToDoO25UQdsGILg=="};